import { getUrlParameter, parseJwt } from '../lib/helpers';
import { LoginAPI } from './api';
import { createToken, refreshToken } from './endpoints';

type GenericObject = { [key: string]: any };

export const authClient = {
    login: (appType: string, frameAppId: number) => {
        sessionStorage.setItem('appTypeValue', appType);

        //localStorage.removeItem(`${appType}_token`);
        const urlGUID = getUrlParameter('guid');
        const urlAppID = getUrlParameter('idAplikacija');

        if (urlGUID !== '') {
            sessionStorage.setItem(`${appType}_guid`, urlGUID);
        }

        if (urlAppID !== '') {
            sessionStorage.setItem(`${appType}_appID`, urlAppID);
        }

        const guid = urlGUID !== '' ? urlGUID : sessionStorage.getItem(`${appType}_guid`);
        const appID = urlAppID !== '' ? urlAppID : sessionStorage.getItem(`${appType}_appID`);

        const data: GenericObject = {};

        if (appID) {
            data.aplikacijaId = appID;
        } else {
            data.aplikacijaId = '3';
        }
        if (guid && data.aplikacijaId !== '3') {
            data.guid = guid;
        }

        data.kadroviAplikacijaId = frameAppId;

        // Vladan Radovanovic 2025.10.02 - move JwtToken to Cookie set by server
        //return LoginAPI.post(createToken(), data).then((response) => {
        //localStorage.setItem(`${appType}_token`, response.data.jwtToken);
        // confirmLoginSuccessful(true);
        //});
        return LoginAPI.post(createToken(), data);
    },

    // getAccessToken: () => {
    //     const appTypeValue = localStorage.getItem('appTypeValue');
    //     return localStorage.getItem(`${appTypeValue}_token`);
    // },

    // getParsedToken: () => {
    //     const token = authClient.getAccessToken();
    //     if (typeof token === 'string') {
    //         return parseJwt(token);
    //     }
    //     return {};
    // },

    refreshToken: async () => {
        // const appTypeValue = localStorage.getItem('appTypeValue');

        try {
            // Vladan Radovanovic 2025.10.02 - JwtToken in Cookie, so new endpoint for token refresh is used
            //const token = localStorage.getItem(`${appTypeValue}_token`);
            // const guid =
            //     localStorage.getItem(`${appTypeValue}_appID`) !== '3'
            //         ? localStorage.getItem(`${appTypeValue}_guid`)
            //         : null;

            // if (token !== null) {
            //     const response = await LoginAPI.post(refreshToken(), {
            //         jwtToken: token,
            //         guid: guid,
            //     });

            //     localStorage.setItem(`${appTypeValue}_token`, response.data.jwtToken);
            //     console.log(response);
            // } else {
            //     console.log('Ne postoji token.');
            // }
            await LoginAPI.post(refreshToken());
        } catch (error) {
            console.log(error);
        }
    },

    logout: () => {
        const appTypeValue = sessionStorage.getItem('appTypeValue');

        // localStorage.removeItem(`${appTypeValue}_token`);
        sessionStorage.removeItem(`${appTypeValue}_guid`);
        sessionStorage.removeItem(`${appTypeValue}_appID`);
    },
};
